/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Invoice_WaivedInputs */



/**
* | output |
* | --- |
* | "Waived (pre-activation)" |
*
* @param {Partner_Admin_Invoice_WaivedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_invoice_waived = /** @type {((inputs?: Partner_Admin_Invoice_WaivedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Invoice_WaivedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erlassen (vor Aktivierung)")
	return /** @type {LocalizedString} */ ("Waived (pre-activation)")
});